export default __webpack_public_path__ + "static/media/ally.1e63d408.svg";